// extracted by mini-css-extract-plugin
module.exports = {"flash":"Flash_flash__2KT-c","error":"Flash_error__3gMbM","warning":"Flash_warning__1Xk5X","info":"Flash_info__1oFYk"};